import { render } from "./EngagementScreen.vue?vue&type=template&id=4997462b&scoped=true"
import script from "./EngagementScreen.vue?vue&type=script&lang=js"
export * from "./EngagementScreen.vue?vue&type=script&lang=js"

import "./EngagementScreen.vue?vue&type=style&index=0&id=4997462b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4997462b"]])

export default __exports__